import * as React from 'react';
import { Theme } from 'webapp/theme';

import { useWishListCount } from '@avensia/excite-commercetools/wishlist';
import { styled } from '@glitz/react';
import { TestIdProps } from '@avensia/test-automation';
import { useFlyout } from 'webapp/shell/flyout-context';
import { translate } from '@avensia/excite';
import { Button } from 'webapp/components/button';
import { HeartIcon } from 'webapp/components/icons';
import { NnTestIdProps } from 'webapp/shared/test-ids';

export const WishListButton = styled(() => {
  const count = useWishListCount();
  const [runAnimation, setRunAnimation] = React.useState(false);
  const { open } = useFlyout('Wishlist');

  React.useEffect(() => {
    setRunAnimation(true);
  }, [count]);

  return (
    <IconButton
      onClick={open}
      disableRippleEffect
      square
      as={Theme.Transparent}
      aria-label={translate(t => t.header.favorites)}
    >
      <HeartIcon {...TestIdProps.MyWishlistLink} />
      {count > 0 && (
        <ItemCount
          css={runAnimation && pulseAnimationDecorator}
          onAnimationEnd={() => setRunAnimation(false)}
          {...NnTestIdProps.HeaderMyWishlinkIconCount}
        >
          {count}
        </ItemCount>
      )}
    </IconButton>
  );
});

const pulseAnimationDecorator = styled({
  animation: {
    name: {
      '0%': {
        boxShadow: t => `0 0 0 0 ${t.headerIndicators.favourites.backgroundColor}61`,
      },
      '70%': {
        boxShadow: t => `0 0 0 10px ${t.headerIndicators.favourites.backgroundColor}00`,
      },
      '100%': {
        boxShadow: t => `0 0 0 0 ${t.headerIndicators.favourites.backgroundColor}00`,
      },
    },
    duration: 2000,
  },
});

const IconButton = styled(Button, {
  position: 'relative',
  overflow: 'visible',
});

const ItemCount = styled.span({
  backgroundColor: t => t.headerIndicators.favourites.backgroundColor,
  color: t => t.headerIndicators.favourites.color,
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 20,
  width: 20,
  top: 4,
  right: 4,
  borderRadius: '50%',
  fontSize: t => t.sharedFontSize.xxxs,
});
